import React, { useState, useEffect } from 'react';
import './ReportsModal.css';
import * as Yup from 'yup';
import Form from '../../form/components/Form/Form';
import FormField from '../../form/components/FormField/FormField';
import Button from '../../form/components/Button/Button';
import ErrorMessage from '../../form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { FaCloudUploadAlt, FaTrashAlt } from  'react-icons/fa';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import ProgressBar from '../../Progress/Progress';
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs, addDoc, getDoc, updateDoc   } from "firebase/firestore"; 
import { getStorage,  ref, uploadBytesResumable, getDownloadURL, deleteObject} from 'firebase/storage';

import { firebaseApp,  } from '../../../utils/firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";
import { useTranslation } from 'react-i18next';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
    code: '',
    name: '',
    phone: '',
}

const override = {
    marginTop: '20px'
  };



function LabAddPatientModal({ onClose, onContentAdded } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const currentDate = moment();
    const [user] = useAuthState(auth);
    const { t, i18n } = useTranslation();

    // REPORT PDF
    const [reportPdfUrl, setReportPdfUrl] = useState<any>('');
    const [reportsPdfProgress,  setReportPdfProgress] = useState(0);
    const [isUploadingReportPdf, setIsUploadingReportPdf] = useState(false);

    // END OF ASSIGNEMTN
    const storage = getStorage(firebaseApp);
    

    // good
    const solutionFileRef: any = useRef(null);

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(`${t('lab.add_modal.code_required')}`),
        name: Yup.string().required(`${t('lab.add_modal.name_required')}`),
        phone: Yup.string().min(9, `${t('lab.add_modal.phone_digit')}`).max(9, `${t('lab.add_modal.digit_min')}`).required(`${t('lab.add_modal.digit_required')}`),
    })




    const handleSubmitReport = async (values: any) => {

            const formattedDate = currentDate.format('YYYY-MM-DD');
            // const cityRef = doc(firebaseApp, 'Cases', values.case_id);
            setLoading(true);

            const reqData: any = {
                patient_name: values.name,
                patient_code: values.code,
                phone: `+237${values.phone}`,
                owner: user?.uid,
                created_at: formattedDate,
                patientExist: false,
                patient_uid: null,
                reports: []
            }

            //CHECK  IF PATIENT HAS ACCOUNT
            const q = query(collection(db, "Patients"), where("phoneNumber", "==", reqData.phone));

            const querySnapshot = await getDocs(q);
            
            // console.log('LENGTH: ', querySnapshot.size);

            if(querySnapshot.size > 0) {
                reqData.patientExist = true;
                reqData.patient_uid = querySnapshot.docs[0].id;
            }
           try {
            
            //CHECK IF PATIENT  HAS ALREADY BEEN ADDED UNDER THIS LAB
            const check = query(collection(db, "Reports"), where("phone", "==", reqData.phone), where("owner", "==", user?.uid));
            const checkQuerySnapshot = await getDocs(check);

            if(checkQuerySnapshot.size > 0) {
                setLoading(false);
                onClose();
                toast.error(`${t('lab.add_modal.phone_exist')}`, {
                    pauseOnHover: false,
                    closeOnClick: true,
                })
                return;
            }

            const docRef = collection(db,"Reports")
        
           await addDoc(docRef, reqData);

            setLoading(false);
            onClose();
            onContentAdded();
            toast.success(`${t('lab.add_modal.success')}`, {
                pauseOnHover: false,
                closeOnClick: true,
            })

        
           } catch (error) {
            // console.log('DATA: ', error);
            setLoading(false);
            toast.error("ERROR", {
                pauseOnHover: false,
                closeOnClick: true,
            })
           }
    }


    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">{`${t('lab.add_modal.add_text')}`}</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitReport}
                    validationSchema={validationSchema}
                >
    

                        <p className="label-text">{`${t('lab.add_modal.code')}`}: </p>
                        <FormField  name="code" type="text" placeholder={`${t('lab.add_modal.code_label')}`}/>

                        <p className="label-text">{`${t('lab.add_modal.patient_name')}`}: </p>
                        <FormField  name="name" type="text" placeholder={`${t('lab.add_modal.patient_name_label')}`}/>

                        <p className="label-text">{`${t('lab.add_modal.patient_phone')}`}: </p>
                        <FormField  name="phone" type="text" placeholder={`${t('lab.add_modal.patient_phone_label')}`}/>

 
                   
                      {!loading && <Button isOutLined={true} isFullWidth={false} title={`${t('lab.add_modal.btn_text')}`}/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default LabAddPatientModal;

